import axios, { AxiosResponse } from 'axios';

export const getMineTeamRooms = (): Promise<AxiosResponse> =>
	axios.get(`/snaps/share`);

export const deleteMineTeamRoom = (id: string): Promise<AxiosResponse> =>
	axios.delete(`/snaps/share/${id}`);

export const shareSnap = (id: string): Promise<AxiosResponse> =>
	axios.post(`/snaps/share`, { id });

export const loadMoreTeamRooms = (page: number): Promise<AxiosResponse> =>
	axios.get(`/snaps/share?page=${page}`);
